module.exports = __webpack_public_path__ + "static/img/hd.a77d187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/hd.png
// module id = z7vC
// module chunks = 215